import { render } from "./SearchSortFilterTable.vue?vue&type=template&id=b26094ae"
import script from "./SearchSortFilterTable.vue?vue&type=script&lang=js"
export * from "./SearchSortFilterTable.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3683024678/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__